import React from "react";

function About() {
  return (
    <div>
      <h1> Page Not Found </h1>
    </div>
  );
}

export default About;
